module.exports = __webpack_public_path__ + "ee6a496e0996437ed0ea6cdc941ae975.MP3";